import { toast } from "../components/message"
import { storeOrder } from "../mobile"
import { formataData } from "../utils"

export function validaAgendamento() {
    const inputAgendamento = select('#agendamento-enable')
    if (inputAgendamento && inputAgendamento.checked) {
        const data = select('#agendamento-data')
        const time = select('#agendamento-hora')

        if (data.value == '' || time.value == '') {
            toast('Informe a data e hora para agendar o pedido')       
            return false    
        } else {
            const hora = time.value.length == 8 ? time.value : time.value + ':00'

            if (data && time) {
                const date = new Date(
                    data.value.split('/').reverse().join('/') + ' ' + hora,
                )

                if (date === NaN) {
                    toast('Data inválida')
                    return false
                } else {
                    // verifica se a data é maior que a data atual
                    if (date < new Date()) {
                        toast('Data e hora devem ser maiores que a data atual')
                        return false
                    } else {
                        storeOrder.DataEntrega = formataData({ data: date }).dataString
                        storeOrder.HoraEntrega = hora
                        storeOrder.DataEntregaTicks = (date.getTime() * 10000 + 621355968000000000).toString()
                    }
                }
            }
        }
    }

    return true
}
